import React from 'react';

const MinParkingHours = ({ minParkingHours }) => (
  <p className="text-color-medium-grey text-size-20 text-weight-book" key="min-hours-notice">
    Stay for <span className="important">{minParkingHours}</span> hours
  </p>
);

export default MinParkingHours;
